 <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.add_team_members' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_team_members_list' | translate }}</p>
          </div>
        </div>


<div class="card">
  <div class="card-body">
   <form #contractForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
  <div class="row">


                 <div class="col-3">
                        <div class="form-group">
                            <label class="form-label required-field">{{ 'MENU.DASHBOARD.partner_logo' | translate }}</label>
                           
                            <!-- منطقة رفع الملف -->
                            <div class="file-upload-container">
                                <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)" #fileInput>
                                <div class="file-upload-label">
                                    <i class="fas fa-cloud-upload-alt file-upload-icon" style="color: #cca44c;"></i>
                                    <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_logo' | translate }}</div>
                                    <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                                    <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
                                </div>
                            </div>

                            <!-- معاينة الصورة الحالية -->
                            <div class="preview-container" *ngIf="formData.image && !previewUrl">
                                <div class="preview-header">
                                    <span class="preview-title">{{ 'MENU.DASHBOARD.current_logo' | translate }}</span>
                                </div>
                                <img [src]="formData.image" class="logo-preview" alt="Current Logo">
                                <div class="preview-actions mt-2">
                                    <button type="button" class="btn btn-outline btn-sm" (click)="removeCurrentLogo()">
                                        <i class="fas fa-trash me-1"></i> {{ 'MENU.DASHBOARD.remove_current' | translate }}
                                    </button>
                                </div>
                            </div>

                            <!-- معاينة الصورة الجديدة المختارة -->
                            <div class="preview-container" *ngIf="previewUrl">
                                <div class="preview-header">
                                    <span class="preview-title">{{ 'MENU.DASHBOARD.new_logo_preview' | translate }}</span>
                                </div>
                                <img [src]="previewUrl" class="logo-preview" alt="New Logo Preview">
                                <!-- <div class="preview-actions mt-2">
                                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeNewLogo()">
                                        <i class="fas fa-times me-1"></i> {{ 'MENU.DASHBOARD.remove_new' | translate }}
                                    </button>
                                    <button type="button" class="btn btn-outline-success btn-sm" (click)="confirmNewLogo()">
                                        <i class="fas fa-check me-1"></i> {{ 'MENU.DASHBOARD.confirm_logo' | translate }}
                                    </button>
                                </div> -->
                            </div>
                            
                            <!-- رسالة إذا مافيش صورة -->
                            <div class="no-preview" *ngIf="!formData.image && !previewUrl">
                                <div class="no-preview-content">
                                    <i class="fas fa-image no-preview-icon"></i>
                                    <div class="form-hint"> {{ 'MENU.DASHBOARD.no_logo_uploaded' | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
 <!-- Name -->
    <div class="col-md-12">
      <div class="mb-3">
        <label class="form-label required-field">
          {{ 'MENU.DASHBOARD.name' | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="formData.name"
          name="name"
          #name="ngModel"
          required
          [class.is-invalid]="name.invalid && name.touched"
        />
        <div *ngIf="name.invalid && name.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.name' | translate }}
        </div>
      </div>
    </div>

    <!-- Job Title -->
    <div class="col-md-12">
      <div class="mb-3">
        <label class="form-label required-field">
          {{ 'MENU.DASHBOARD.job_title' | translate }}
        </label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="formData.job_title"
          name="job_title"
          #jobTitle="ngModel"
          required
          [class.is-invalid]="jobTitle.invalid && jobTitle.touched"
        />
        <div *ngIf="jobTitle.invalid && jobTitle.touched" class="text-danger small mt-1">
          {{ 'MENU.DASHBOARD.job_title' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- Submit -->
  <div class="row">
    <div class="col-sm-4">
      <div class="mb-3 d-flex justify-content-start">
        <button
          type="submit"
          class="btn"
          [disabled]="contractForm.invalid"
          style="background-color: #cca44c !important; color: #fff;"
        >
          {{ 'MENU.DASHBOARD.add' | translate }}
        </button>
      </div>
    </div>
  </div>
</form>

  </div>
</div>
